/**
 * Exposes the Swiper build already bundled inside vendor.js as a global.
 *
 * The theme instantiates its own carousels with `new MinimogLibs.Swiper(...)`
 * (see theme-global.js), while the custom sections call the bare global
 * `new Swiper(...)`. That mismatch is the only reason a second, full copy of
 * Swiper (~140 KB) used to be loaded — render-blocking — in the head. Aliasing
 * the bundled copy drops that download entirely.
 *
 * Must load after vendor.js. Both are deferred, so they execute in document
 * order and finish before DOMContentLoaded, which is where every `new Swiper`
 * call site runs.
 */
(function () {
  if (window.Swiper) return;

  var libs = window.MinimogLibs;
  if (libs && libs.Swiper) {
    window.Swiper = libs.Swiper;
    return;
  }

  console.warn('[swiper-alias] MinimogLibs.Swiper not found — carousels may not initialise.');
})();
